import React from 'react';
import topBanner from '../Assets/img/topBanner.png';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Link to={`/`} className='btn btn-success btn-sm'>
            <img src={topBanner} alt='Banner' style={{ width: '100%' }} />
          </Link>
        </div>
      </div>

      <div className='container mt-4'>
        <h2>Privacy Policy</h2>
        <p>
          <strong>Juice@Home</strong> is committed to protecting the privacy and personal data of our customers. This policy explains how we collect, use, and protect your information.
        </p>

        <h5 className="mt-3">Information We Collect</h5>
        <ul>
          <li>Full name, contact number, email address</li>
          <li>Delivery address and apartment/society name</li>
          <li>Order history and payment details (processed securely via third-party gateways)</li>
        </ul>

        <h5 className="mt-4">How We Use Your Information</h5>
        <ul>
          <li>To process and deliver your juice orders</li>
          <li>To communicate order confirmations and delivery updates</li>
          <li>To send promotional offers and updates (you can opt-out anytime)</li>
          <li>To improve our services and delivery experience</li>
        </ul>

        <h5 className="mt-4">Data Sharing</h5>
        <ul>
          <li>We do <strong>not</strong> sell or rent your personal data to any third parties.</li>
          <li>We may share limited information with our delivery partners only for fulfillment purposes.</li>
        </ul>

        <h5 className="mt-4">Data Security</h5>
        <ul>
          <li>Your personal data is stored securely and access is restricted to authorized personnel only.</li>
          <li>All payments are processed through secure and compliant payment gateways.</li>
        </ul>

        <h5 className="mt-4">Your Rights</h5>
        <ul>
          <li>You can request to access, update, or delete your personal data anytime by contacting us at <strong>info@erelatelabs.com</strong>.</li>
        </ul>

        <p className="mt-3">
          By using our website or placing an order, you agree to this privacy policy.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
